<template>
    <div>
       <v-card>
            <v-card-title>
                <v-btn small dark color="blue"
                    :disabled="usuarios.length === 0"
                    @click="asigHorarioDep=true">Asignar a todos</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar..."
                single-line
                hide-details
            ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="usuarios"
                :search="search"
                :rows-per-page-items="[15,30,100]"
                :rows-per-page-text="'Resultados por página'"
            >
            <template v-slot:items="props">
                <td>
                    <v-menu
                        v-if="puedeAsignarHorario"
                        transition="scale-transition"
                        origin="left top"
                        bottom
                        right
                        slot="activator"
                    >
                        <v-btn class="ma-0" icon slot="activator">
                            <v-icon>more_vert</v-icon>
                        </v-btn>
                        <v-list class="app-card-action">
                            <v-list-tile @click="asignarHorarioDialog(props.item._id,props.item.horario)">
                                <i class="fa fa-retweet blue--text mr-2 fs-14"></i>
                                <span>Asignar horario</span>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                </td>
                <td>{{ props.item.codigo }}</td>
                <td>{{ props.item.paterno }}</td>
                <td>{{ props.item.materno }}</td>
                <td>{{ props.item.nombre }}</td>
                <td v-if="!props.item.horario"></td>
                <td v-else>{{ props.item.horario.nombre }}</td>
                
            </template>
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                No se encontraron resultados para la búsqueda "{{ search }}".
                </v-alert>
            </template>
            </v-data-table>
        </v-card>

        <asignar-horario 
            v-if="asigHorario.mostrar"
            :mostrar="asigHorario.mostrar"
            :horario="asigHorario.horario"
            :usuario="asigHorario.usuario"
            @cancelarAsigHorario="asigHorario.mostrar=false"
            @horarioAsignado="horarioIndividualAsignado"
            @enviandoStart="$emit('enviandoStart')"
            @enviandoStop="$emit('enviandoStop')"
        />


        <asignar-horario-dep 
            v-if="asigHorarioDep"
            :mostrar="asigHorarioDep"
            :dependencia="dependencia"
            @cancelarAsigHorario="asigHorarioDep=false"
            @horarioDepAsignado="horarioDepAsignado"
            @enviandoStart="$emit('enviandoStart')"
            @enviandoStop="$emit('enviandoStop')"
        />


    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from '../../../components/Loader'
import AsignarHorario from '../../personal/asignarHorario'
import AsignarHorarioDep from './asignarHorarioDep'

import axios from 'axios'
import moment from 'moment'
export default {
    name: 'HorariosDependencia',
    props:['usuarios','dependencia'],
	components: {
        Loader,
        AsignarHorario,
        AsignarHorarioDep
    },
    computed: {
    ...mapGetters([
        "sessionToken",
        "httpURL",
        "userId",
        "tableProps",
        "role",
        "permisos"
      ]),
      puedeAsignarHorario(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 179) >= 0 ? true : false;
        },
    },
    created(){
        // console.log(this.usuarios);
        axios.get(this.httpURL+'/horarios/dependencias/listado',{headers:{token: this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                this.dependencias = res.data.dependencias;
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
    data() {
        return {
            asigHorario: {
                mostrar : false,
                usuario: null,
                horario: null
            },
            asigHorarioDep: false,
            search: null,
            headers:[
                { text: '', value: 'Options', sortable: false },
                { text: 'Codigo', value: 'codigo' },
                { text: 'Paterno', value: 'paterno' },
                { text: 'Materno', value: 'materno' },
                { text: 'Nombre', value: 'nombre' },
                { text: 'Horario', value: 'horario' },
                // { text: 'Empleados', value: 'empleados' }
            ],
        }
    },
    methods:{
        cargarDependencia(){
            // console.log('Dependencia: '+this.dependenciaSel);
        },
        asignarHorarioDialog(usuario, horario){
            this.asigHorario.usuario = usuario;
            this.asigHorario.horario = horario;
            this.asigHorario.mostrar = true;
        },
        horarioIndividualAsignado(horario,usuario){
            this.$emit('horarioIndividualAsignado',horario,usuario);
        },
        horarioDepAsignado(horario){
            this.$emit('horarioDepAsignado',horario);
        }
    }
}
</script>